import styles from './Loaders.module.css';

const Loaders = () => {
	return <span className={styles.loader}></span>;
};

export { Loaders };
